import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from '@tanstack/react-query';

import { AdminPageHeader } from '../Common/AdminPagesHeader';
import {
    DIGITAL_SAFETY_LIBRARY,
    DIGITAL_SAFETY_LIBRARY_COLUMNS,
    QUERY_KEYS,
    ROLES,
} from '../../../constants';
import { Table } from '../../shared';
import { usePagination } from '../../../hooks';
import { UploadDigitalDelivery } from '../../shared/Modal/UploadDigitalDelivery';
import { getAllDigitalDelivery, popup } from '../../../utils';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';

export const DigitalSafetyLibrary = () => {
    const [response, setResponse] = useState({
        data: [],
        count: 0,
    });
    const pagination = usePagination(response.data.length, response.count);
    const [search, setSearch] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const role = useSelector((s) => s.user.role);

    const [debouncedSearch] = useDebouncedValue(search, 500);
    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: [
            QUERY_KEYS.DIGITAL_SAFETY_MANUAL,
            debouncedSearch,
            pagination.limit,
            pagination.offset,
        ],
        queryFn: async () =>
            await getAllDigitalDelivery({
                limit: pagination.limit,
                offset: pagination.offset,
                search: debouncedSearch,
            }),
        select: (data) => ({ data: data.data, count: data.count }),
        placeholderData: { data: [], count: 0 },
    });

    if (isError) popup('error', error.message);

    useEffect(() => {
        if (data && isFetched) {
            setResponse(data);
        }
    }, [data, isFetched]);

    return (
        <>
            <AdminPageHeader
                showAddButton={role !== ROLES.SALES_AGENT}
                heading={DIGITAL_SAFETY_LIBRARY.PAGE_HEADING}
                buttonText={DIGITAL_SAFETY_LIBRARY.ADD_BUTTON_TEXT}
                handleAddClick={() => {
                    setShowAddModal(true);
                }}
                AddModal={
                    showAddModal ? (
                        <UploadDigitalDelivery
                            showAddModal={showAddModal}
                            setShowAddModal={setShowAddModal}
                        />
                    ) : (
                        ''
                    )
                }
                backbutton
                showSearchBar
                searchBarPlaceholder={DIGITAL_SAFETY_LIBRARY.FILE_NAME_SEARCH}
                count={pagination.dataCount}
                setSearch={setSearch}
            />

            <Table
                columns={DIGITAL_SAFETY_LIBRARY_COLUMNS}
                data={response.data}
                pagination={pagination}
                pageName={DIGITAL_SAFETY_LIBRARY.PAGE_HEADING}
                stickyColumns={['File Name']}
                isLoading={isFetching}
            />
        </>
    );
};
